import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import { Capacitor } from '@capacitor/core';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// iOS double-splash fix (two-pronged):
//
// 1. The native LaunchScreen.storyboard references a SEPARATE image asset
//    (AppLogo.imageset) — small fitted logo centered on #06060A.
// 2. The Capacitor SplashScreen plugin auto-renders Splash.imageset on iOS
//    using scaleAspectFill. We replaced Splash.imageset PNGs with a solid
//    #06060A image, so even if the plugin overlay shows briefly it is
//    visually invisible (matches the storyboard background). Result: only
//    the storyboard logo is ever visible — no stacked/cropped duplicate.
// 3. As an extra safety net, we still call SplashScreen.hide() as soon as
//    JS runs, in case the plugin overlay flashes before the WebView paints.
(async () => {
  try {
    if (!Capacitor.isNativePlatform()) return;
    const { SplashScreen } = await import('@capacitor/splash-screen');
    await SplashScreen.hide({ fadeOutDuration: 0 });
  } catch {
    /* plugin unavailable — ignore */
  }
})();

// Register service worker for PWA — but ONLY in a browser context.
// Inside Capacitor (iOS/Android native shell) the page is served from
// capacitor://localhost and registering an SW there hijacks asset requests
// and produces a black screen.
const isCapacitorNative = (() => {
  try { return Capacitor.isNativePlatform(); } catch { return false; }
})();

if ('serviceWorker' in navigator && !isCapacitorNative) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js', { updateViaCache: 'none' })
      .then((reg) => {
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (installing) {
            installing.addEventListener('statechange', () => {
              if (installing.state === 'installed' && navigator.serviceWorker.controller) {
                installing.postMessage({ type: 'SKIP_WAITING' });
              }
            });
          }
        });
      })
      .catch(() => {});

    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}
